import bigCheckIcon from 'assets/images/landing/big-check.png'
import biometryIcon from 'assets/images/landing/biometry.png'
import diamondIcon from 'assets/images/landing/diamond.png'
import flashIcon from 'assets/images/landing/flash.png'
import onlineIcon from 'assets/images/landing/online.png'
import Container from 'components/UI/Landing/container'
import SectionTitle from 'components/UI/Landing/section-title'
import { useTranslation } from 'react-i18next'
import { randomId } from 'utils'

import ProsCard from './pros-card.view'

const pros = [
  {
    id: randomId(),
    title: 'pros-section.first-pros',
    body: 'pros-section.first-pros-note',
    icon: onlineIcon
  },
  {
    id: randomId(),
    title: 'pros-section.second-pros',
    body: 'pros-section.second-pros-note',
    icon: flashIcon
  },
  {
    id: randomId(),
    title: 'pros-section.third-pros',
    body: 'pros-section.third-pros-note',
    icon: diamondIcon
  },
  {
    id: randomId(),
    title: 'pros-section.fourth-pros',
    body: 'pros-section.fourth-pros-note',
    icon: biometryIcon
  },
  {
    id: randomId(),
    title: 'pros-section.fifth-pros',
    body: 'pros-section.fifth-pros-note',
    icon: bigCheckIcon
  }
]

export type ProsItem = {
  id: string
  title: string
  body: string
  icon: string
}
export default function ProsSection(): JSX.Element {
  const { t } = useTranslation('landing')

  return (
    <section className='py-[40px] lg:py-16'>
      <Container>
        <SectionTitle title={t('pros-section.title')} />
        <div className='mt-10'>
          {pros.map((item, idx) => (
            <ProsCard key={item.id} prosNumber={idx + 1} {...item} />
          ))}
        </div>
      </Container>
    </section>
  )
}
